import React, { FC, useContext } from 'react';
import { BuySideMobile } from '../BuySideMobile';
import { SellSideMobile } from '../SellSideMobile';
import MembersContext from 'router/subrouters/DataRoom/providers/Members/Members.context';
import { Loader } from 'ncoded-component-library';

type MembersMobileProps = {
  onlyNew?: boolean;
};

const MembersMobile: FC<MembersMobileProps> = ({ onlyNew = false }) => {
  const { isLoading, buySideNewMembers, sellSideNewMembers } =
    useContext(MembersContext);

  return (
    <div className="members__container">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {onlyNew && !buySideNewMembers.length ? null : (
            <BuySideMobile onlyNew={onlyNew} />
          )}

          {onlyNew && !sellSideNewMembers.length ? null : (
            <SellSideMobile onlyNew={onlyNew} />
          )}
        </>
      )}
    </div>
  );
};

export default MembersMobile;
